import {
  VStack,
  Tabs,
  TabList,
  Tab,
  TabIndicator,
  Divider,
  TabPanels,
  TabPanel,
  Box,
} from '@chakra-ui/react';

import { EventLogger, TaskDocuments, TaskThreads } from '.';
import { DetailedTask, FileStatus } from '../../../models';
import {
  useGetAllFormFeaturesQuery,
  useGetTaskEventLogsQuery,
  useGetTaskDocumentsQuery,
  useGetTaskThreadsQuery,
} from '../../../services';
import { CenteredSpinner } from '../../../components';
import { stringToPascalCase } from '../../../utils';
import { useEffect, useState } from 'react';
import { LinkedTask } from './LinkedTask';

export const FeaturesTabs = ({
  taskData,
  files,
  setFiles,
  openTask,
}: {
  taskData: DetailedTask;
  setFiles: React.Dispatch<
    React.SetStateAction<
      {
        file: File;
        status: FileStatus;
      }[]
    >
  >;
  openTask: any;
  files: { file: File; status: FileStatus }[];
}) => {
  const [activeFormFeatures, setActiveFormFeatures] = useState<
    { id: number; name: string }[]
  >([]);
  const { data: taskEventLogs, isLoading: isTaskEventLogsLoading } =
    useGetTaskEventLogsQuery(taskData.id);

  const { data: taskFiles, isLoading: isTaskFilesLoading } =
    useGetTaskDocumentsQuery(taskData.id);

  const { data: formFeatures, isLoading: isFormFeaturesLoading } =
    useGetAllFormFeaturesQuery();

  const { data: taskThreads, isLoading: isTaskThreadsLoading } =
    useGetTaskThreadsQuery(taskData.id);

  console.log('formFeatures', taskThreads, taskData, taskEventLogs);
  useEffect(() => {
    if (formFeatures?.data) {
      setActiveFormFeatures(
        formFeatures.data
          .filter(
            ({ id }) =>
              taskData.workflow.form.features.find(
                feature => feature.featureTypeId === id
              )?.isEnabled
          )
          .map(({ id, name }) => ({ id, name }))
      );
    }
  }, [formFeatures?.data]);

  const renderFeatureBasedOnSameTabsOrder = (
    name: 'logs' | 'documents' | 'threads'
  ) => {
    switch (name) {
      case 'logs':
        return (
          <TabPanel h="92%" overflowY="scroll">
            <VStack align="stretch">
              {taskEventLogs?.data.content.map(event => (
                <EventLogger event={event} key={event.id} />
              ))}
            </VStack>
          </TabPanel>
        );

      case 'documents':
        return (
          <TabPanel h="92%" overflowY="scroll">
            <TaskDocuments
              documents={taskFiles?.data}
              taskId={taskData.id}
              files={files}
              setFiles={setFiles}
            />
          </TabPanel>
        );

      case 'threads':
        return (
          <TabPanel h="92%" overflowY="scroll">
            <TaskThreads threads={taskThreads?.data} taskId={taskData.id} />
          </TabPanel>
        );
    }
  };
console.log("first",activeFormFeatures)
  return (
    <VStack
      bg="white"
      border="1px"
      borderColor="custom_gray.10"
      borderRadius="md"
      h="full"
      flexBasis="25%"
      hidden={!activeFormFeatures.length}
      align="stretch"
    >
      {isFormFeaturesLoading || isTaskFilesLoading ? (
        <CenteredSpinner />
      ) : (
        <Tabs
          position="relative"
          variant="unstyled"
          colorScheme="orange"
          bg="white"
          borderRadius="md"
          w="full"
          h="full"
        >
          <Box px="4">
            <TabList justifyContent="space-evenly">
              {activeFormFeatures.map(({ name }) => (
                <Tab
                  key={name}
                  fontSize="sm"
                  fontWeight="semibold"
                  color="custom_gray.1"
                  _selected={{ color: 'custom_orange.2' }}
                >
                  {stringToPascalCase(name)}
                </Tab>
              ))}
              {taskData.taskHierarchy && taskData.taskHierarchy.length > 0 && (
                <Tab
                  key="sub-tasks"
                  fontSize="sm"
                  fontWeight="semibold"
                  color="custom_gray.1"
                  _selected={{ color: 'custom_orange.2' }}
                >
                  Sub Forms
                </Tab>
              )}
            </TabList>

            <TabIndicator
              mt="-1.5px"
              height="2px"
              bg="custom_orange.2"
              borderRadius="1px"
            />

            <Divider />
          </Box>

          <TabPanels h="full">
            {/* we do that to keep the same sorting of the tabs above */}
            {activeFormFeatures.map(feature =>
              renderFeatureBasedOnSameTabsOrder(
                feature.name as 'logs' | 'documents' | 'threads'
              )
            )}
            {taskData.taskHierarchy && taskData.taskHierarchy.length > 0 && (
              <TabPanel h="92%" overflowY="scroll">
                <VStack align="stretch">
                  {[
                    ...taskData.taskHierarchy,
                    {
                      id: taskData.id,
                      name: taskData.name,
                      level: 0,
                      createdAt: taskData.createdAt,
                      status: taskData.status,
                      modifiedAt: taskData.modifiedAt,
                    },
                  ]
                    .sort((a, b) => a.level - b.level)
                    .map((task, index) => (
                      <LinkedTask
                        key={task.id}
                        task={task}
                        openTask={openTask}
                        version={index + 1}
                      />
                    ))}
                </VStack>
              </TabPanel>
            )}
          </TabPanels>
        </Tabs>
      )}
    </VStack>
  );
};
